import { createAction, createReducer } from "@reduxjs/toolkit";
import { loginUser } from "./login-user";
import { markSessionTerminated } from "@user-management-context/write/application/use-cases/session/session-reducer";
import type { ProcessingState } from "@redux/state/shared-types";

const initialState: ProcessingState = { processing: "idle" };

export const resetLoginUserState = createAction("users/loginUser/reset");

export const loginUserReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(loginUser.fulfilled, state => {
    return { ...state, processing: "success" };
  });
  builder.addCase(loginUser.pending, state => {
    return { ...state, processing: "pending" };
  });
  builder.addCase(loginUser.rejected, state => {
    return { ...state, processing: "failed" };
  });
  builder.addCase(resetLoginUserState, () => initialState);
  // A login form has no object once the session it opened is over. LoginPage would
  // normally reset this on unmount, but LoginOutlet redirects away from /login as
  // soon as a user is loaded, so it never mounts after a successful login — leaving
  // "success" in the store to greet, much later, whoever lands back on the login
  // screen. (Resetting on markSessionActive would not work: loginUser awaits
  // syncSession, so that action fires *before* loginUser.fulfilled sets "success".)
  builder.addCase(markSessionTerminated, () => initialState);
});
